module.exports = __webpack_public_path__ + "static/media/carousalImageTwo.45dbcf2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/carousalImageTwo.jpg
// module id = 25
// module chunks = 0